import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function UnauthorizedPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <Result
      status="403"
      title={t('unauthorizedTitle')}
      subTitle={t('unauthorizedSubtitle')}
      extra={
        <Button type="primary" onClick={() => navigate('/dashboard')}>
          {t('unauthorizedBackHome')}
        </Button>
      }
    />
  );
}
